import { h } from "preact";
import md5 from "md5";

import classname from "../../../foundation/utils/classname";
import { getResizedImageSources } from "../../../foundation/utils/image";

import styles from "./BarrelThumbnail.module.css";

const COLORS = [
    "#fff4ce", "#e4eeff", "#ffe8d1", "#ffecec",
    "#def4e9", "#f0e8f7", "#f7eef7", "#e8f7e8",
    "#ffe8f4", "#e6e6f4", "#e9f6d0", "#e3f4f4"
];
const [DEFAULT_COLOR] = COLORS;
const HORIZONTAL_PADDING = 24;

const colorCache = new Map<string, string>();

function getColor(seed: string) {
    if (colorCache.has(seed)) {
        return colorCache.get(seed);
    }

    const index = Array.from(md5(seed)).reduce((previous, current) => previous + current.charCodeAt(0), 0);
    const color = COLORS[index % COLORS.length];
    colorCache.set(seed, color);

    return color;
}

interface Props {
    class?: string;
    width: number;
    height: number;
    url?: string;
    colorSeed?: string;
}

export default function BarrelThumbnail({
    class: cssClass,
    width,
    height,
    url,
    colorSeed
}: Props) {
    const color = colorSeed ? getColor(colorSeed) : DEFAULT_COLOR;
    // eslint-disable-next-line no-magic-numbers
    const imageWidth = width - HORIZONTAL_PADDING * 2;

    return (
        <div
            style={{
                width,
                height,
                backgroundColor: color
            }}
            class={classname(styles.barrelThumbnail, cssClass)}>
            {url && (
                <img
                    class={styles.image}
                    {...getResizedImageSources(url, { width: imageWidth })}/>
            )}
        </div>
    );
}
